import { SyntheticEvent, useState } from 'react';
import { useParams } from 'react-router-dom';
import ArrowIcon from '../../../../../assets/images/blogForm/arrowIcon';
import { updateOrganizationAdmin } from '../../../../../services/bussines';
import { IOrganizationUserData } from '../../../../../types/bussines';
import { displayErrorNotification, displaySuccessNotification } from 'utils/displayNudosStandardNotifications';

import './UserInformation.scss';

const UserInformation = ({
  userData,
  dataWasUpdated,
  setDataWasUpdated
}: {
  userData: IOrganizationUserData;
  dataWasUpdated: number;
  setDataWasUpdated: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const { organizationId } = useParams<{ organizationId: string }>();
  const [currentRole, setCurrentRole] = useState<string>();

  const updateOrganizationAdministrator = async () => {
    if (!userData?.id || !organizationId) return;
    try {
      const updateOrganizationAdminResponse = await updateOrganizationAdmin(userData.id, organizationId);
      if (updateOrganizationAdminResponse) {
        setDataWasUpdated(dataWasUpdated + 1);
        displaySuccessNotification({ customJSXMessage: <>Se actualizó la información correctamente</> });
      }
    } catch (error) {
      displayErrorNotification();
    }
  };

  const handleUpdateUserRole = (event: SyntheticEvent) => {
    const { value } = event.target as HTMLSelectElement;
    if (value === 'Admin') {
      updateOrganizationAdministrator();
    } else {
      displaySuccessNotification({ customJSXMessage: <>Asigna el rol de administrador a otro usuario para que se guarden los cambios</> });
      setCurrentRole(value);
    }
  };

  return (
    <div className="userInformation">
      <div className="roleContainer">
        <div className="label">Rol</div>
        <select
          className="inputElement roleInput"
          value={userData.role === 'admin' ? 'Admin' : currentRole || 'Usuario'}
          onChange={handleUpdateUserRole}
        >
          <option>Admin</option>
          <option>Usuario</option>
        </select>
      </div>
      <div className="firstNameContainer">
        <div className="label disabled">Nombre</div>
        <input type="text" className="inputElement" value={userData.firstName || ''} disabled />
      </div>
      <div className="lastNameContainer">
        <div className="label disabled">Apellido</div>
        <input type="text" className="inputElement" value={userData.lastName || ''} disabled />
      </div>
      <div className="emailContainer">
        <div className="label disabled">Correo</div>
        <input type="text" className="inputElement" value={userData.email || ''} disabled />
        <div className="emailHover">{userData?.email}</div>
      </div>
      <div className="phoneContainer">
        <div className="label disabled">Número de contacto</div>
        <div className="flagAndNumber">
          <div className="countryCodeContainer">
            {userData?.phoneData?.flag && <img className="flag" src={userData?.phoneData?.flag} alt="Bandera" />}
            {userData?.phoneData?.phoneCode && <div className="countryCode">+{userData?.phoneData?.phoneCode}</div>}
            <ArrowIcon className="arrow" />
          </div>
          <input type="text" className="inputElement phoneNumber" value={userData?.phoneData?.phone} disabled />
        </div>
      </div>
    </div>
  );
};

export default UserInformation;
